module.exports = __webpack_public_path__ + "static/silence-6e7388de28a7b1bd31f3954f98e884d9.jpg";